export enum SuggestionsTab {
  PENDING = 'pending',
  RESOLVED = 'resolved',
}
